// import { Link } from '@tanstack/react-router';
// import { routes } from '@/routes/routes';

import { ArticleContent } from '@/components/layout/ArticleContent';

export const PrivacyPolicyPage = () => {
  return (
    <ArticleContent>
      <h1>EternaLife Privacy Policy</h1>
      <p>Last Updated: Martch 29 th, 2024</p>
      <h2>Introduction</h2>
      <p>Welcome to EternaLife Limited’s Privacy Policy.</p>
      <p>
        EternaLife respects your privacy and is committed to protecting your
        personal information. This Privacy Policy will inform you as to how we
        look after your personal information when you
      </p>
      <ul>
        <li>visit our website (regardless of where you visit it from);</li>
        <li>
          give consent to third parties to provide your personal information to
          us, or
        </li>
        <li>provide information to us instore</li>
      </ul>
      <p>
        and tell you about your privacy rights and how the law protects you.
      </p>
      <p>
        This Privacy Policy is provided in a layered format so you can click
        through to the specific areas set out below. Please also use the
        Glossary to understand the meaning of some of the terms used in this
        Privacy Policy.
      </p>
      <h2>1. Important information and who we are</h2>
      <h3>PURPOSE OF THIS PRIVACY POLICY</h3>
      <p>
        This Privacy Policy aims to give you information on how EternaLife
        collects and processes your personal information through your use of
        this website or when you provide information in store, including any
        data you may provide when purchasing a product or service.
      </p>
      <p>
        This website is not intended for children and we do not knowingly
        collect data relating to children.
      </p>
      <p>
        It is important that you read this Privacy Policy together with any
        other privacy notice we may provide on specific occasions when we are
        collecting or processing personal information about you so that you are
        fully aware of how and why we are using your data. This Privacy Policy
        supplements the other notices and is not intended to override them.
      </p>
      <h3>CONTROLLER</h3>
      <p>
        EternaLife Limited, company number 14775595, registered office address
        85 Great Portland Street, First Floor, London, England, W1W 7LT, United
        Kingdom
      </p>
      <p>
        EternaLife Limited is the controller and responsible for your personal
        responsible for your personal information (collectively referred to as
        "EternaLife", "we", "us" or "our" in this privacy notice). EternaLife
        Limited is the controller and responsible for this website.
      </p>
      <h3>
        CHANGES TO THE PRIVACY POLICY AND YOUR DUTY TO INFORM US OF CHANGES
      </h3>
      <p>
        This version was last updated on March 29-th, 2024 and historic versions
        are archived
      </p>
      <p>
        It is important that the personal information we hold about you is
        accurate and up to date. Please let us know if your personal information
        changes during your relationship with us. You can update your
        information at any time by amending your personal information within the
        Your Account section at EternaLife.co.uk.
      </p>
      <h3>THIRD-PARTY LINKS</h3>
      <p>
        This website may include links to third-party websites, plug-ins and
        applications. Clicking on those links or enabling those connections may
        allow third parties to collect or share data about you. We do not
        control these third-party websites and are not responsible for their
        privacy statements. When you leave our website, we encourage you to read
        the privacy notice of every website you visit.
      </p>
      <h2>2. The data we collect about you</h2>
      <p>
        Personal Data, or Personal Information, means any information about an
        individual from which that person can be identified. It does not include
        data where the identity has been removed (anonymous data).
      </p>
      <p>
        We may collect, use, store and transfer different kinds of Personal
        Information about you which we have grouped together as follows:
      </p>
      <ul>
        <li>
          <b>Identity Data</b> includes first name, maiden name, last name,
          username or similar identifier, gender, title, date of birth, email
          address.
        </li>
        <li>
          <b>Contact Data</b> includes billing address, delivery address, email
          address and telephone number.
        </li>
        <li>
          <b>Financial Data</b> includes bank account and payment card details.
        </li>
        <li>
          <b>Genetic Data</b> includes information regarding your genotype
          (e.g., the As, Ts, Cs, and Gs at particular locations in your DNA) and
          length of your telomeres.
        </li>
        <li>
          <b>Health Data</b> includes your disease conditions and genetic
          traits.
        </li>
        <li>
          <b>Transaction Data</b> includes details about payments to and from
          you and other details of products and services you have purchased from
          us.
        </li>
        <li>
          <b>Profile Data</b> includes your username and password, purchases or
          orders made by you, your interests, preferences, feedback and survey
          responses.
        </li>
        <li>
          <b>Usage Data</b> includes information about how you use our website,
          products and services, your br/owsing activity including intended
          purchases and aborted baskets, completion of surveys, wish-lists,
          connection information and statistics on your visits to site and page
          views, the links you click and other actions you take on our services,
          within our advertising or e-mail content and participation in
          promotional activity. <b>Marketing and Communications Data</b>{' '}
          includes your preferences in receiving marketing from us and our third
          parties and your communication preferences.
        </li>
        <li>
          <b>Marketing and Communications Data</b> includes your preferences in
          receiving marketing from us and our third parties and your
          communication preferences. Unless you are an EternaLife user, we do
          not collect any Special Categories of Personal Information about you
          (this includes details about your race or ethnicity, religious or
          philosophical beliefs, sex life, sexual orientation, political
          opinions and trade union membership). Nor do we collect any
          information about criminal convictions and offences.
        </li>
      </ul>
      <p>
        Unless you are a EternaLife user, we do not collect any{' '}
        <b>Special Categories of Personal information</b> about you (this
        includes details about your race or ethnicity, religious or
        philosophical beliefs, sex life, sexual orientation, political opinions
        and trade union membership). Nor do we collect any information about
        criminal convictions and offences.
      </p>
      <h3>IF YOU FAIL TO PROVIDE PERSONAL INFORMATION</h3>
      <p>
        Where we need to collect Personal Information by law, or under the terms
        of a contract we have with you and you fail to provide that data when
        requested, we may not be able to perform the contract we have or are
        trying to enter into with you (for example, to provide you with goods or
        services). In this case, we may have to cancel a product or service you
        have with us but we will notify you if this is the case at the time.
      </p>
      <h2>3. How is your Personal Data collected</h2>
      <p>
        We capture, process and retain Personal Information from you and any
        devices you may use when you navigate to a EternaLife.co.uk web or
        mobile view, by transacting, by registering an account and otherwise
        interacting with us. We may also collect Personal Information from you
        if you physically enter into one of our stores or attend an event.
      </p>
      <p>
        Furthermore, we obtain your Personal Data from your healthcare
        specialist or treatment facility based on the consent you grant them,
        authorizing the transfer of your Personal Data to us.
      </p>
      <p>
        We may capture customer information, purchase data and br/owsing
        behaviour as part of the rewards for life loyalty programme. This is so
        we can optimise and personalise your experience with EternaLife.co.uk.
      </p>
      <p>
        Some more examples of the different methods by which we collect
        information from and about you include through:
      </p>
      <ul>
        <li>
          <b>Direct interactions.</b> You may give us your Identity, Contact and
          Financial Data by filling in forms or by corresponding with us by
          post, phone, email or otherwise. This includes Personal Information
          you provide when you
          <ul>
            <li>
              register or purchase our products or services through the site or
              mobile app;
            </li>
            <li>return a product to store;</li>
            <li>create an account on our website;</li>
            <li>subscribe to our services or publications;</li>
            <li>request marketing to be sent to you;</li>
            <li>contact our customer service team;</li>
            <li>
              enter a competition, promotion, survey or complete a
              questionnaire; or
            </li>
            <li>give us feedback</li>
          </ul>
        </li>
        <li>
          <b>Automated technologies or interactions.</b> As you interact with
          our website, we may automatically collect Technical Data about your
          equipment, br/owsing actions and patterns. We collect this Personal
          Information by using cookies, server logs and other similar
          technologies. These machine learning algorithms generate content which
          they apply to personalising your experience and select more
          specifically the items you have an interest in as well as supporting
          general service optimisation including bid/ markdown automation. You
          may find more information of the use of cookies below in our{' '}
          {/* TODO: Cookie Policy link - route not defined in routes.ts */}
          {/* <Link to={routes.legal.cookiePolicy}>Cookie Policy</Link> */}
          Cookie Policy
        </li>
      </ul>
      <h2>4. How we use your Personal Data</h2>
      <p>
        We will only use your Personal Information when the law allows us to.
        Most commonly, we will use your Personal Information in the following
        circumstances:
      </p>
      <ul>
        <li>
          Where we need to perform the contract we are about to enter into or
          have entered into with you.
        </li>
        <li>
          Where it is necessary for our legitimate interests (or those of a
          third party) and your interests and fundamental rights do not override
          those interests.
        </li>
        <li>
          Where we need to comply with a legal or regulatory obligation. Please
          see point 5 below (Purposes for which we will use your Personal
          Information) to find out more about the types of lawful basis that we
          will rely on to process your Personal Information.
        </li>
      </ul>
      <p>
        Please see point 5 below (Purposes for which we will use your personal
        information) to find out more about the types of lawful basis that we
        will rely on to process your personal information.
      </p>
      <h2>5. Purposes for which we will use your information</h2>
      <p>
        We have set out below, in a table format, a description of all the ways
        we plan to use your Personal Information, and which of the legal bases
        we rely on to do so. We have also identified what our legitimate
        interests are where appropriate.
      </p>
      <p>
        In general terms, we use the Personal Information we collect to help
        EternaLife Limited better understand you and to enable us to personalise
        your experience with EternaLife, including offers, promotions and
        services to meet your needs. We use your information to:
      </p>
      <ul>
        <li>
          personalise our services, offers and promotions to you and provide you
          with a personalised experience on our sites;
        </li>
        <li>process your online orders and in-store purchases;</li>
        <li>
          offer you site content that includes items that you might like and to
          keep track of your basket;
        </li>
        <li>
          contact you about your account and tell you about important changes at
          EternaLife Limited;
        </li>
        <li>provide, develop and improve our products and services;</li>
        <li>provide you customer service;</li>
        <li>
          manage promotions, competitions, customer surveys and questionnaires;
        </li>
        <li>
          check and verify your identity, and prevent, mitigate or detect and
          investigate crime, fraudulent or illegal activities; and
        </li>
        <li>
          process purchases, payments, customer support and order fulfilment.
        </li>
      </ul>
      <table>
        <tr>
          <th>Purpose/Activity</th>
          <th>Type of data</th>
          <th>
            Lawful basis for processing including basis of legitimate interest
          </th>
        </tr>
        <tr>
          <td>To register you as a new customer</td>
          <td>
            (a) Identity
            <br />
            (b) Contact
            <br />
            (c) Special Categories of Personal information*
          </td>
          <td>
            (a) Performance of a contract with you
            <br />
            (b) Consent
          </td>
        </tr>
        <tr>
          <td>
            To provide services to you as defined in our{' '}
            {/* TODO: Terms and Conditions link - route not yet implemented in Router.tsx */}
            {/* <Link to={routes.legal.termsAndConditions}>Terms and Conditions</Link> */}
            Terms and Conditions
          </td>
          <td>(a) Special Categories of Personal information*</td>
          <td>(a) Consent</td>
        </tr>
        <tr>
          <td>
            To process and deliver your order including:
            <br />
            (a) Manage payments, fees and charges
            <br />
            (b) Collect and recover money owed to us
          </td>
          <td>
            (a) Identity
            <br />
            (b) Contact
            <br />
            (c) Financial
            <br />
            (d) Transaction
            <br />
            (e) Marketing and Communications
          </td>
          <td>
            (a) Performance of a contract with you
            <br />
            (b) Necessary for our legitimate interests (to recover debts due to
            us)
            <br />
            (c) Consent
          </td>
        </tr>
        <tr>
          <td>
            To manage our relationship with you which will include:
            <br />
            (a) Notifying you about changes to our terms or privacy policy{' '}
            <br />
            (b) Asking you to leave a review or take a survey
          </td>
          <td>
            (a) Identity
            <br />
            (b) Contact
            <br />
            (c) Profile
            <br />
            (d) Marketing and Communications
          </td>
          <td>
            (a) Performance of a contract with you
            <br />
            (b) Necessary to comply with a legal obligation
            <br />
            (c) Necessary for our legitimate interests (to keep our records
            updated and to study how customers use our products/services)
            <br />
            (d) Consent
          </td>
        </tr>
        <tr>
          <td>
            To enable you to partake in a prize draw, competition or complete a
            survey
          </td>
          <td>
            (a) Identity
            <br />
            (b) Contact
            <br />
            (c) Profile
            <br />
            (d) Usage
            <br />
            (e) Marketing and Communications
          </td>
          <td>
            (a) Performance of a contract with you
            <br />
            (b) Necessary for our legitimate interests (to study how customers
            use our products/services, to develop them and grow our business)
            <br />
            (c) Consent
          </td>
        </tr>
        <tr>
          <td>
            To administer and protect our business and this website (including
            troubleshooting, data analysis, testing, system maintenance,
            support, reporting and hosting of data) and to prevent, detect,
            mitigate and investigate fraudulent or illegal activities
          </td>
          <td>
            (a) Identity
            <br />
            (b) Contact
            <br />
            (c) Technical
            <br />
            (d) Financial
            <br />
            (e) Usage
          </td>
          <td>
            (a) Necessary for our legitimate interests (for running our
            business, provision of administration and IT services, network
            security, to prevent fraud and in the context of a business
            reorganisation or group restructuring exercise)
            <br />
            (b) Necessary to comply with a legal obligation
          </td>
        </tr>
        <tr>
          <td>
            To deliver relevant website content and advertisements to you and
            measure or understand the effectiveness of the advertising we serve
            to you
          </td>
          <td>
            (a) Identity
            <br />
            (b) Contact
            <br />
            (c) Profile
            <br />
            (d) Usage
            <br />
            (e) Marketing and Communications
            <br />
            (f) Technical
          </td>
          <td>
            (a) Necessary for our legitimate interests (to study how customers
            use our products/services, to develop them, to grow our business and
            to inform our marketing strategy)
            <br />
            (b) Consent
          </td>
        </tr>
        <tr>
          <td>
            To use data analytics to improve our website, products/services,
            marketing, customer relationships and experiences
          </td>
          <td>
            (a) Technical
            <br />
            (b) Usage
          </td>
          <td>
            (a) Necessary for our legitimate interests (to define types of
            customers for our products and services, to keep our website updated
            and relevant, to develop our business and to inform our marketing
            strategy)
            <br />
            (b) Consent
          </td>
        </tr>
        <tr>
          <td>
            To make suggestions and recommendations to you about goods or
            services that may be of interest to you
          </td>
          <td>
            (a) Identity
            <br />
            (b) Contact
            <br />
            (c) Technical
            <br />
            (d) Usage
            <br />
            (e) Profile
            <br />
            (f) *Special Categories of Personal information
          </td>
          <td>
            (a) Necessary for our legitimate interests (to develop our
            products/services and grow our business);
            <br />
            (b) In limited circumstances we rely on consent (see Promotional
            Offers From Us below)
          </td>
        </tr>
      </table>
      <p>
        * Special Categories of Personal Information include your Health Data
        and Genetic Data.
      </p>
      <h3>PROMOTIONAL OFFERS FROM US</h3>
      <p>
        We may use your Identity, Contact, Technical, Usage and Profile, Health
        and Genetic Data to form a view on what we think you may want or need,
        or what may be of interest to you. This is how we decide which products,
        services and offers may be relevant for you (we call this marketing). We
        will get your express opt-in consent before we use your personal
        information for providing you with promotional offers.
      </p>
      <h3>THIRD-PARTY MARKETING</h3>
      <p>
        We will get your express opt-in consent before we share your personal
        information with any company outside the EternaLife Limited for
        marketing purposes.
      </p>
      <h3>OPTING OUT</h3>
      <p>
        You can ask us or third parties to stop sending you marketing messages
        at any time by logging into the website and checking or unchecking
        relevant boxes at Your Account to adjust your marketing preferences or
        by following the opt-out links on any marketing message sent to you.
      </p>
      <h3>CHANGE OF PURPOSE</h3>
      <p>
        We will only use your Personal Information for the purposes for which we
        collected it, unless we reasonably consider that we need to use it for
        another reason and that reason is compatible with the original purpose.
      </p>
      <p>
        If we need to use your Personal Information for an unrelated purpose, we
        will notify you and we will explain the legal basis which allows us to
        do so.
      </p>
      <p>
        Please note that we may process your Personal Information without your
        knowledge or consent, in compliance with the above rules, where this is
        required or permitted by law.
      </p>
      <h2>6. Disclosures of your Personal Data</h2>
      <p>
        We may have to share your Personal Information with the parties set out
        below for the purposes set out in the table in paragraph 4 above.
      </p>
      <ul>
        <li>Internal Third Parties as set out in the Glossary below.</li>
        <li>External Third Parties as set out in the Glossary below.</li>
        <li>
          Third parties to whom we may choose to sell, transfer, or merge parts
          of our business or our assets. Alternatively, we may seek to acquire
          other businesses or merge with them. If a change happens to our
          business, then the new owners may use your Personal Information in the
          same way as set out in this Privacy Policy.
        </li>
      </ul>
      <p>
        We require all third parties to respect the security of your Personal
        Information and to treat it in accordance with the law. We do not allow
        our third-party service providers to use your Personal Information for
        their own purposes and only permit them to process your Personal
        Information for specified purposes and in accordance with our
        instructions.
      </p>
      <h2>7. International Transfers</h2>
      <p>
        Many of our External Third Parties are based outside the European
        Economic Area (<b>EEA</b>) so their processing of your Personal
        Information will involve a transfer of data outside the EEA.
      </p>
      <p>
        Whenever we transfer your Personal Information out of the EEA, we ensure
        a similar degree of protection is afforded to it by ensuring at least
        one of the following safeguards is implemented:
      </p>
      <ul>
        <li>
          We will only transfer your Personal Information to countries that have
          been deemed to provide an adequate level of protection for Personal
          Information by the European Commission.
        </li>
        <li>
          Where we use certain service providers, we may use specific contracts
          approved by the European Commission which give Personal Information
          the same protection it has in Europe. For further details, see{' '}
          <i>European Commission Standard Contractual Clauses (SCC)</i>.
        </li>
        <li>
          Where we use providers based in the US, we may transfer data to them
          if they are part of the Data Privacy Framework which requires them to
          provide similar protection to Personal Information shared between the
          Europe and the US.
        </li>
      </ul>
      <h2>8. Data Security</h2>
      <p>
        We have put in place appropriate security measures to prevent your
        Personal Information from being accidentally lost, used or accessed in
        an unauthorised way, altered or disclosed. In addition, we limit access
        to your Personal Information to those employees, agents, contractors and
        other third parties who have a business need to know. They will only
        process your Personal Information on our instructions and they are
        subject to a duty of confidentiality.
      </p>
      <p>
        We have put in place procedures to deal with any suspected Personal
        Information br/each and will notify you and any applicable regulator of
        a br/each where we are legally required to do so.
      </p>
      <h2>9. Data Retention</h2>
      <h3>HOW LONG WILL YOU USE MY PERSONAL INFORMATION FOR?</h3>
      <p>
        We will only retain your Personal Information for as long as necessary
        to fulfil the purposes we collected it for, including for the purposes
        of satisfying any legal, accounting, or reporting requirements. In
        addition, this includes that we may retain Personal Information from
        closed accounts to comply with legal requirements, prevent fraud and
        resolve disputes. After it is no longer necessary for us to retain your
        Personal Information, we dispose of it securely according to our data
        retention and deletion policies
      </p>
      <p>
        When we determine the maximum retention duration of any Personal Data we
        hold we do so with regard to our legitimate interests to retain data,
        our obligation under GDPR to minimise data we hold, the amount, nature,
        and sensitivity of the Personal Information, the potential risk of harm
        from unauthorised use or disclosure of your Personal Information, the
        purposes for which we process your Personal Information and whether we
        can achieve those purposes through other means, and the applicable legal
        requirements.
      </p>
      <p>
        By law we have to keep basic information about our customers (including
        Contact, Identity, Financial and Transaction Data) for six years after
        they cease being customers for tax purposes.
      </p>
      <p>
        In some circumstances you can ask us to delete your data: see Withdraw
        consent in section <b>10. Your Legal Rights</b> below for further
        information.
      </p>
      <p>
        In some circumstances we may anonymise your Personal Information (so
        that it can no longer be associated with you) for research or
        statistical purposes in which case we may use this information
        indefinitely without further notice to you.
      </p>
      <h2>10. Your legal rights</h2>
      <p>
        Under certain circumstances, you have rights under data protection laws
        in relation to your Personal Information. Please see below to find out
        more about these rights and access the{' '}
        {/* TODO: Contact/request forms link - route not defined in routes.ts */}
        {/* <Link to={routes.help.contact}>request forms</Link> */}
        request forms should you want to make any of these requests:
      </p>
      <p>
        If you wish to exercise any of the rights set out above, please send the{' '}
        {/* TODO: Contact/completed forms link - route not defined in routes.ts */}
        {/* <Link to={routes.help.contact}>completed forms</Link> */}
        completed forms to us to the e-mail or postal address included on the
        form.
      </p>
      <h3>NO FEE USUALLY REQUIRED</h3>
      <p>
        You will not have to pay a fee to access your Personal Information (or
        to exercise any of the other rights). However, we may charge a
        reasonable fee if your request is clearly unfounded, repetitive or
        excessive. Alternatively, we may refuse to comply with your request in
        these circumstances.
      </p>
      <h3>WHAT WE MAY NEED FROM YOU</h3>
      <p>
        We may need to request specific information from you to help us confirm
        your identity and ensure your right to access your Personal Information
        (or to exercise any of your other rights). This is a security measure to
        ensure that Personal Information is not disclosed to any person who has
        no right to receive it. We may also contact you to ask you for further
        information in relation to your request to speed up our response. In
        some cases, we may demonstrate that we have compelling legitimate
        grounds to process your information which override your rights and
        freedoms. You can update your marketing preferences at any time by
        contacting us. Navigate to the Contact us section.
      </p>
      <h3>WHAT ARE YOUR RIGHTS</h3>
      <p>
        You always have the right to obtain a confirmation that your Personal
        Data is being processed, to access your Personal Data which is being
        processed or to require correction of inaccurate or incomplete data.
      </p>
      <br />
      <p>
        You shall also have the right to erasure (“right to be forgotten”) of
        your Personal Data on the grounds specified in the General Data
        Protection Regulation 2016//679. You can exercise the above mentioned
        rights at any time by contacting us. Navigate to the Contact us section.
      </p>
      <p>
        <b>Request restriction of processing</b> of your Personal Information.
        This enables you to ask us to suspend the processing of your Personal
        Information in the following scenarios: (a) if you want us to establish
        the data’s accuracy; (b) where our use of the data is unlawful but you
        do not want us to erase it; (c) where you need us to hold the data even
        if we no longer require it as you need it to establish, exercise or
        defend legal claims; or (d) you have objected to our use of your data
        but we need to verify whether we have overriding legitimate grounds to
        use it. You can request restriction of processing by{' '}
        {/* TODO: Contact us link - route not defined in routes.ts */}
        {/* <Link to={routes.help.contact}>contacting us</Link> */}
        contacting us .
      </p>
      <p>
        <b>Withdraw consent at any time</b> where we are relying on consent to
        process your Personal Information. However, this will not affect the
        lawfulness of any processing carried out before you withdraw your
        consent. If you withdraw your consent, we may not be able to provide
        certain products or services to you. We will advise you if this is the
        case at the time you withdraw your consent. You can withdraw your
        consent at any time by{' '}
        {/* TODO: Contact us link - route not defined in routes.ts */}
        {/* <Link to={routes.help.contact}>contacting us</Link> */}
        contacting us .
      </p>
      <h2>11. Glossary</h2>
      <h3>LAWFUL BASIS</h3>
      <p>
        <b>Legitimate Interest</b> means the interest of our business in
        conducting and managing our business to enable us to give you the best
        service/product and the best and most secure experience. We make sure we
        consider and balance any potential impact on you (both positive and
        negative) and your rights before we process your Personal Information
        for our legitimate interests. We do not use your Personal Information
        for activities where our interests are overridden by the impact on you
        (unless we have your consent or are otherwise required or permitted to
        by law).
      </p>
      <p>
        <b>Performance of Contract</b> means processing your data where it is
        necessary for the performance of a contract to which you are a party or
        to take steps at your request before entering into such a contract.
      </p>
      <p>
        <b>Comply with a legal or regulatory obligation</b> means processing
        your Personal Information where it is necessary for compliance with a
        legal or regulatory obligation that we are subject to.
      </p>
      <h3>THIRD PARTIES</h3>
      <h3>EXTERNAL THIRD PARTIES</h3>
      <ul>
        <li>
          Service providers acting as processors who provide IT, system
          administration services, payment providers to facilitate purchases,
          fulfilment providers to facilitate order management, packaging and
          delivery and marketing and communications services providers in order
          to personalise your experience and communicate with you.
        </li>
        <li>
          Professional advisers including lawyers, bankers, auditors and
          insurers who provide consultancy, banking, legal, insurance and
          accounting services.
        </li>
        <li>
          HM Revenue & Customs, regulators, law enforcement bodies and other
          authorities acting as processors or joint controllers based in the
          United Kingdom who require reporting of processing activities in
          certain circumstances and otherwise in defence of legal claims.
        </li>
        <li>
          Market researchers, fraud prevention agencies and analytics providers.
        </li>
      </ul>
      <h2>Contact Us</h2>
      <p>
        Our contact address is: 85 Great Portland Street, First Floor, London,
        England. you can email us at{' '}
        <a href="mailto:info@eternalife.co.uk">info@eternalife.co.uk</a>.
      </p>
    </ArticleContent>
  );
};
